import React from 'react';

import { ARRAY_EMPTY } from '@libs/constants';

import { IFastGameContext } from './types';

export const FastGameContext = React.createContext<IFastGameContext>({
  isLoading: true,
  playerId: '',
  selected: ARRAY_EMPTY,
  select() {},
  reset() {},
});
